import React, { useEffect, useState } from "react";
import { Mic2, RefreshCw, Radio } from "lucide-react";
import { api } from "@/lib/api";

function authHeaders() {
  const t = localStorage.getItem("fliboe_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

/** Admin tools for the platform-wide founder voice drop (DJ Anup intro). */
export default function FounderDropCard() {
  const [drop, setDrop] = useState(null);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");

  const refresh = async () => {
    try {
      const { data } = await api.get("/founder-drop");
      setDrop(data);
    } catch (_) {
      setDrop(null);
    }
  };
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/founder-drop");
        if (alive) setDrop(data);
      } catch (_) {
        if (alive) setDrop(null);
      }
    })();
    return () => { alive = false; };
  }, []);

  const generate = async () => {
    if (!window.confirm("Regenerate the founder voice drop? This will burn ~$0.01 of TTS credits and replace the current MP3 for all new listener sessions.")) return;
    setBusy("generate"); setMsg("");
    try {
      const { data } = await api.post("/admin/founder-drop/generate", {}, { headers: authHeaders() });
      setMsg(`Generated v${data.version} · ${Math.round(data.duration)}s · ${Math.round(data.size_bytes / 1024)} KB`);
      await refresh();
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Generate failed");
    }
    setBusy("");
  };

  const installOnTalk = async () => {
    if (!window.confirm("Replace ALL tracks on Fliboe Talk with the founder drop on loop? This clears the current Fliboe Talk playlist.")) return;
    setBusy("install"); setMsg("");
    try {
      const { data } = await api.post("/admin/founder-drop/install-on-station", {}, { headers: authHeaders() });
      setMsg(`Fliboe Talk now loops the founder drop · removed ${data.removed_tracks} old track(s)`);
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Install failed");
    }
    setBusy("");
  };

  return (
    <section className="mt-10" data-testid="founder-drop-card">
      <h2 className="fl-display text-2xl font-bold mb-4 flex items-center gap-2">
        <Mic2 className="w-5 h-5 text-emerald-500" /> Founder voice drop
      </h2>
      <div className="fl-card p-5">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="min-w-[220px] flex-1">
            <div className="text-white font-medium">DJ Anup — Welcome to Fliboe</div>
            <div className="text-xs text-slate-400 mt-1">
              {drop ? (
                <>Active · v{drop.version} · {Math.round(drop.duration)}s. Plays once per listener session, before the first station tunes in.</>
              ) : (
                <>No drop generated yet. Click &ldquo;Regenerate&rdquo; to synthesize the founder script with OpenAI TTS.</>
              )}
            </div>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={generate}
              disabled={busy === "generate"}
              className="fl-btn ghost"
              data-testid="founder-drop-generate"
            >
              <RefreshCw className={`w-4 h-4 text-emerald-500 ${busy === "generate" ? "animate-spin" : ""}`} />
              {busy === "generate" ? "Generating…" : drop ? "Regenerate" : "Generate now"}
            </button>
            <button
              onClick={installOnTalk}
              disabled={busy === "install" || !drop}
              className="fl-btn"
              data-testid="founder-drop-install-on-talk"
              title={drop ? "Replace all Fliboe Talk tracks with this drop on loop" : "Generate the drop first"}
            >
              <Radio className="w-4 h-4" />
              {busy === "install" ? "Installing…" : "Install on Fliboe Talk"}
            </button>
          </div>
        </div>
        {msg && (
          <div className="mt-3 text-xs text-emerald-400" data-testid="founder-drop-msg">{msg}</div>
        )}
      </div>
    </section>
  );
}
